// Import html-to-image for better color support and Next.js compatibility
// Use dynamic import to avoid bundling issues
let htmlToImagePng = null;
const getHtmlToImage = async () => {
  if (!htmlToImagePng) {
    try {
      const module = await import('html-to-image');
      htmlToImagePng = module.toPng;
    } catch (e) {
      console.error('Failed to load html-to-image:', e);
      throw new Error('html-to-image library not available');
    }
  }
  return htmlToImagePng;
};

// Add a simple test to verify the library is working
export function testScreenshotLibrary() {
  console.log('Testing html-to-image library...');
  console.log('Available functions:', Object.keys(htmlToImagePng));
  return true;
}

export async function captureScreenshot() {
  const widgetElements = document.querySelectorAll('.br-widget, .br-trigger-btn');
  
  try {
    // Hide widget elements
    widgetElements.forEach(el => {
      if (el) el.style.display = 'none';
    });

    // Capture full viewport - simple and reliable
    const toPng = await getHtmlToImage();
    const dataUrl = await toPng(document.body, {
      quality: 0.95,
      pixelRatio: window.devicePixelRatio || 1,
      width: window.innerWidth,
      height: window.innerHeight,
      backgroundColor: '#ffffff',
      filter: (node) => {
        return !node.classList?.contains('br-widget') && 
               !node.classList?.contains('br-trigger-btn');
      }
    });

    // Convert data URL to blob
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Screenshot capture failed:', error);
    // Return null instead of throwing - the bug report can still work without screenshot
    return null;
  } finally {
    // Always restore widget elements
    widgetElements.forEach(el => {
      if (el) el.style.display = '';
    });
  }
}

export async function captureScreenshotArea(rect) {
  // Simply call captureScreenshot - no area selection, just full viewport
  // This avoids all coordinate/scroll issues
  return await captureScreenshot();
}

// Improved fallback using native canvas API
async function captureScreenshotWithCanvas() {
  return new Promise((resolve, reject) => {
    try {
      // Create a temporary canvas to capture the visible portion
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Set canvas size to viewport
      const width = window.innerWidth;
      const height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      
      // Fill with white background
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);
      
      // Try to draw the document content using a simpler approach
      // This is a basic fallback - it won't capture everything but will work
      ctx.fillStyle = '#333333';
      ctx.font = '14px Arial';
      
      let y = 30;
      const lineHeight = 20;
      
      // Add page information
      ctx.fillText('Bug Reporter Screenshot', 20, y);
      y += lineHeight;
      ctx.fillText(`Page: ${window.location.href}`, 20, y);
      y += lineHeight;
      ctx.fillText(`Size: ${width}x${height}`, 20, y);
      y += lineHeight;
      ctx.fillText(`Time: ${new Date().toLocaleString()}`, 20, y);
      y += lineHeight * 2;
      
      // Try to capture some basic page content
      const title = document.title || 'No title';
      ctx.fillText(`Title: ${title}`, 20, y);
      y += lineHeight;
      
      const bodyText = document.body?.innerText?.substring(0, 200) || 'No content';
      ctx.fillText(`Content: ${bodyText}`, 20, y);
      
      canvas.toBlob((blob) => {
        if (blob) {
          console.log('Fallback screenshot created successfully');
          resolve(blob);
        } else {
          reject(new Error('Failed to create canvas screenshot'));
        }
      }, 'image/png');
    } catch (error) {
      console.error('Canvas fallback failed:', error);
      reject(error);
    }
  });
}